<div class="modal-header">
  <h3 class="modal-title">Gerando mapa</h3>
</div>

<div class="modal-body text-center">
  <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>

  <p ng-if="loadingMapasWarning" class="text-danger padding-top-10">
    <small>{{loadingMapasWarning}}</small>
  </p>
</div>
